import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=4e2d6b3c&scoped=true&"
import script from "./AddGoods.vue?vue&type=script&lang=ts&"
export * from "./AddGoods.vue?vue&type=script&lang=ts&"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=4e2d6b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d6b3c",
  null
  
)

export default component.exports